import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className: string;
}

export const Layout = styled.span<IProps>`
  ${mixin.flex({ justify: 'space-between' })}
  position: relative;
  border: 1px solid #e2e2e2;
  background-color: #fff;

  &.allClear {
    .btn-clear {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      //background-color: red;
      right: 5px;
      width: 30px;
      height: 30px;

      .inner {
        position: relative;
        display: inline-block;
        width: 20px;
        height: 20px;
        top: 1px;
        background-color: #d9d9d9;
        border-radius: 50%;

        &:before,
        &:after {
          content: '';
          display: inline-block;
          width: 1px;
          height: 13px;
          background-color: #fff;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-45deg);
        }

        &:after {
          transform: translate(-50%, -50%) rotate(45deg);
        }
      }
    }

    input {
      padding-right: 40px;
    }

    input:placeholder-shown {
      padding-right: 0;
    }

    input:placeholder-shown + .btn-clear {
      display: none;
    }

    input:not(:placeholder-shown) + .btn-clear {
      display: inline-block;
    }
  }

  &.searchBtn {
    .btn-serach {
      width: 26px;
      height: 26px;
      flex: none;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    &.allClear {
      .btn-clear {
        right: ${mixin.pxToVw('5')};
        width: ${mixin.pxToVw('30')};
        height: ${mixin.pxToVw('30')};

        .inner {
          width: ${mixin.pxToVw('20')};
          height: ${mixin.pxToVw('20')};
          top: ${mixin.pxToVw('1')};

          &:before,
          &:after {
            width: ${mixin.pxToVw('1')};
            height: ${mixin.pxToVw('13')};
          }
        }
      }

      input {
        padding-right: ${mixin.pxToVw('40')};
      }
    }
  }
`;

export const Box = styled.span`
  ${mixin.flex({
    display: 'inline-flex',
    justify: 'flex-start',
    // align: 'flex-start',
  })};
  position: relative;
  width: 100%;
`;

export const Addon = styled.span`
  display: inline-block;
  position: relative;
`;

export const Input = styled.input`
  font-size: 14px;
  line-height: 135%;
  color: #000;
  border: 0;

  &:focus-visible {
    outline: none;
  }
`;
